var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditcards = function SvgCreditcards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.597v-22.24c0-2.532 2.056-4.59 4.59-4.59h1.027v-4.38c0-2.524 2.047-4.575 4.574-4.575h33.236c2.526 0 4.574 2.05 4.574 4.575V30.5c0 2.526-2.05 4.575-4.574 4.575H42.6v4.522c0 2.535-2.055 4.59-4.59 4.59H4.59c-2.533 0-4.59-2.055-4.59-4.59zm39.233 0v-10.86H3.368v10.86c0 .675.548 1.223 1.223 1.223h33.42c.675 0 1.223-.548 1.223-1.223zM44.63 30.5V19.703H42.6v12.006h.826c.664 0 1.205-.54 1.205-1.207zm-5.397-8.744v-4.398c0-.674-.55-1.223-1.222-1.223H4.59c-.673 0-1.222.55-1.222 1.223v4.398h35.865zm5.398-8.996V8.387c0-.667-.54-1.208-1.204-1.208H10.19c-.663 0-1.205.54-1.205 1.207v4.373H44.63z"
  })));
};
export default SvgCreditcards;